import axios from "axios";
import label from "@/lang/StaticLabels.js";
const hamsazUrl = "sale/api/v1/";

export default {
  // ProjectType Actions ------------------------------------------------------------------
  getProjectTypes({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "basic/hamsaz/ProjectType?" + data)
      .then((res) => {
        commit("setProjectTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addProjectType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "basic/hamsaz/ProjectType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editProjectType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamsazUrl + "basic/hamsaz/ProjectType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteProjectType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "basic/hamsaz/ProjectType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getProjectTypeCode({ dispatch, commit }) {
    axios
      .get(hamsazUrl + "basic/hamsaz/ProjectType/MaxCode")
      .then((res) => {
        commit("setProjectTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // Unit Actions ------------------------------------------------------------------
  getUnits({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "basic/UnitCount")
      .then((res) => {
        commit("setUnits", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addUnit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "basic/UnitCount", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editUnit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamsazUrl + "basic/UnitCount/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteUnit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "basic/UnitCount/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getUnitCode({ dispatch, commit }) {
    axios
      .get(hamsazUrl + "basic/UnitCount/GetMaxCode")
      .then((res) => {
        commit("setUnitCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // Blocks Actions ------------------------------------------------------------------
  getBlocks({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "operation/hamsaz/Block")
      .then((res) => {
        commit("setBlocks", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addBlock({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "operation/hamsaz/Block", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBlock({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamsazUrl + "operation/hamsaz/Block/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBlocks({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "operation/hamsaz/Block/", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBlockCode({ dispatch, commit }) {
    axios
      .get(hamsazUrl + "operation/hamsaz/Block/MaxCode")
      .then((res) => {
        commit("setBlockCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // Dashboard Actions ------------------------------------------------------------------
  getDashboardList({ dispatch }, resource) {
    return axios
      .get(
        hamsazUrl +
          "operation/hamsaz/" +
          resource +
          "?pageNumber=1&pageSize=1000000",
      )
      .then((res) => {
        const data = res.data && res.data.data;
        if (Array.isArray(data)) return data;
        return (data && data.data) || [];
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  // Project Actions ------------------------------------------------------------------
  getProjects({ dispatch, commit }, data) {
    axios
      .get(hamsazUrl + "operation/hamsaz/Project?" + data)
      .then((res) => {
        commit("setProjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProject({ dispatch, commit }, data) {
    axios
      .get(hamsazUrl + "operation/hamsaz/Project/" + data)
      .then((res) => {
        commit("setProject", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addProject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "operation/hamsaz/Project", data)
      .then((res) => {
        commit("setProjectId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editProject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamsazUrl + "operation/hamsaz/Project/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteProject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "operation/hamsaz/Project", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getProjectCode({ dispatch, commit }) {
    axios
      .get(hamsazUrl + "operation/hamsaz/Project/MaxCode")
      .then((res) => {
        commit("setProjectCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // WorkDescription Actions ------------------------------------------------------------------
  getWorkDescriptions({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "basic/hamsaz/WorkDescription?" + data)
      .then((res) => {
        commit("setWorkDescriptions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addWorkDescription({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "basic/hamsaz/WorkDescription", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editWorkDescription({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamsazUrl + "basic/hamsaz/WorkDescription/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteWorkDescription({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "basic/hamsaz/WorkDescription", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getWorkDescriptionCode({ dispatch, commit }) {
    axios
      .get(hamsazUrl + "basic/hamsaz/WorkDescription/MaxCode")
      .then((res) => {
        commit("setWorkDescriptionCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // ProjectTeam Actions ------------------------------------------------------------------
  getProjectTeams({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "operation/hamsaz/ProjectTeam?" + data)
      .then((res) => {
        commit("setProjectTeams", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addProjectTeam({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "operation/hamsaz/ProjectTeam", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editProjectTeam({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamsazUrl + "operation/hamsaz/ProjectTeam/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteProjectTeam({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "operation/hamsaz/ProjectTeam", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // GeneralEstimate Actions ------------------------------------------------------------------
  getGeneralEstimates({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "operation/hamsaz/GeneralEstimate?" + data)
      .then((res) => {
        commit("setGeneralEstimates", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addGeneralEstimate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "operation/hamsaz/GeneralEstimate", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editGeneralEstimate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        hamsazUrl + "operation/hamsaz/GeneralEstimate/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteGeneralEstimate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "operation/hamsaz/GeneralEstimate", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // BuildingProject Actions ------------------------------------------------------------------
  getBuildingProject({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "operation/hamsaz/BuildingProject/" + data)
      .then((res) => {
        commit("setBuildingProject", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addBuildingProject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "operation/hamsaz/BuildingProject", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBuildingProject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        hamsazUrl + "operation/hamsaz/BuildingProject/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //Suites Actions ------------------------------------------------------------------
  getSuites({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "operation/hamsaz/Suite?" + data)
      .then((res) => {
        commit("setSuites", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSuitCode({ dispatch, commit }) {
    axios
      .get(hamsazUrl + "operation/hamsaz/Suite/MaxCode")
      .then((res) => {
        commit("setSuitCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addSuites({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "operation/hamsaz/Suite", data)
      .then((res) => {
        commit("setSuiteId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSuites({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamsazUrl + "operation/hamsaz/Suite/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteSuite({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "operation/hamsaz/Suite", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //Participation Actions ------------------------------------------------------------------
  getParticipation({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "operation/hamsaz/participation?" + data)
      .then((res) => {
        commit("setParticipation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getParticipationCode({ dispatch, commit }) {
    axios
      .get(hamsazUrl + "operation/hamsaz/Participation/MaxCode")
      .then((res) => {
        commit("setParticipationCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addParticipation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "operation/hamsaz/Participation", data)
      .then((res) => {
        commit("setParticipationId", res.data.data);

        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editParticipation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamsazUrl + "operation/hamsaz/Participation/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteParticipation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "operation/hamsaz/Participation", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //PaymentNotification Actions ------------------------------------------------------------------
  getPaymentNotification({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "operation/hamsaz/paymentNotification?" + data)
      .then((res) => {
        commit("setPaymentNotification", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPaymentNotificationLog({ dispatch, commit }, data) {
    axios
      .get(hamsazUrl + "hamsaz/Report/PaymentNotificationSmsLog?"+ data)
      .then((res) => {
        commit("setPaymentNotificationLog", res.data.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPaymentNotificationCode({ dispatch, commit }) {
    axios
      .get(hamsazUrl + "operation/hamsaz/PaymentNotification/MaxCode")
      .then((res) => {
        commit("setPaymentNotificationCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addAnnouncement({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "operation/hamsaz/PaymentNotification", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editAnnouncement({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        hamsazUrl + "operation/hamsaz/PaymentNotification/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deletePaymentNotification({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "operation/hamsaz/PaymentNotification", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addSendSms({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "operation/hamsaz/PaymentNotification/SendSms", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //Rank Actions ------------------------------------------------------------------
  getRanks({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "operation/hamsaz/Rank?" + data)
      .then((res) => {
        commit("setRank", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getRankCode({ dispatch, commit }) {
    axios
      .get(hamsazUrl + "operation/hamsaz/Rank/MaxCode")
      .then((res) => {
        commit("setRankCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addRank({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "operation/hamsaz/Rank", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editRank({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamsazUrl + "operation/hamsaz/Rank/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteRank({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "operation/hamsaz/Rank", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //Estimation Actions ------------------------------------------------------------------
  getEstimation({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "operation/hamsaz/CostEstimate?" + data)
      .then((res) => {
        commit("setEstimation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getEstimationItem({ dispatch, commit }, data) {
    axios
      .get(hamsazUrl + "operation/hamsaz/CostEstimate/" + data)
      .then((res) => {
        commit("setEstimationItem", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getEstimationCode({ dispatch, commit }, data) {
    axios
      .get(hamsazUrl + "operation/hamsaz/CostEstimate/MaxCode?" + data)
      .then((res) => {
        commit("setEstimationCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addEstimation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "operation/hamsaz/CostEstimate", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editEstimation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamsazUrl + "operation/hamsaz/CostEstimate/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteEstimation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "operation/hamsaz/CostEstimate", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //Transfer Actions ------------------------------------------------------------------
  getTransfer({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "operation/hamsaz/Transfer?" + data)
      .then((res) => {
        commit("setTransfer", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getTransferCode({ dispatch, commit }) {
    axios
      .get(hamsazUrl + "operation/hamsaz/Transfer/MaxCode")
      .then((res) => {
        commit("setTransferCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addTransfer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "operation/hamsaz/Transfer", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editTransfer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamsazUrl + "operation/hamsaz/Transfer/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteTransfer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "operation/hamsaz/Transfer", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //CrimesReward Actions ------------------------------------------------------------------
  getCrimesReward({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "operation/hamsaz/CrimesReward?" + data)
      .then((res) => {
        commit("setCrimesReward", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCrimesRewardCode({ dispatch, commit }) {
    axios
      .get(hamsazUrl + "operation/hamsaz/CrimesReward/MaxCode")
      .then((res) => {
        commit("setCrimesRewardCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCrimesReward({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "operation/hamsaz/CrimesReward", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCrimesReward({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamsazUrl + "operation/hamsaz/CrimesReward/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteCrimesReward({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "operation/hamsaz/CrimesReward", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //CrimesRewardSubject Actions ------------------------------------------------------------------
  getCrimesRewardSubject({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "basic/hamsaz/CrimesRewardSubject")
      .then((res) => {
        commit("setCrimesRewardSubject", res.data.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCrimesRewardSubjectCode({ dispatch, commit }) {
    axios
      .get(hamsazUrl + "basic/hamsaz/CrimesRewardSubject/MaxCode")
      .then((res) => {
        commit("setCrimesRewardSubjectCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCrimesRewardSubject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "basic/hamsaz/CrimesRewardSubject", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCrimesRewardSubject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        hamsazUrl + "basic/hamsaz/CrimesRewardSubject/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteCrimesRewardSubject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "basic/hamsaz/CrimesRewardSubject", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //EstimationSubject Actions ------------------------------------------------------------------
  getEstimationSubject({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "basic/hamsaz/EstimationSubject")
      .then((res) => {
        commit("setEstimationSubject", res.data.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getEstimationSubjectCode({ dispatch, commit }) {
    axios
      .get(hamsazUrl + "basic/hamsaz/EstimationSubject/MaxCode")
      .then((res) => {
        commit("setEstimationSubjectCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addEstimationSubject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "basic/hamsaz/EstimationSubject", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editEstimationSubject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamsazUrl + "basic/hamsaz/EstimationSubject/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteEstimationSubject({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "basic/hamsaz/EstimationSubject", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //Setting Actions ------------------------------------------------------------------
  getSetting({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "basic/hamsaz/Setting")
      .then((res) => {
        commit("setSetting", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  editSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamsazUrl + "basic/hamsaz/Setting/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //RankingReport Actions ------------------------------------------------------------------
  getRankingReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "hamsaz/Report/RankingSummary?" + data)
      .then((res) => {
        commit("setRankingReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  //RankingDetailReport Actions ------------------------------------------------------------------
  getRankingDetailReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "hamsaz/Report/RankingDetail?" + data)
      .then((res) => {
        commit("setRankingDetailReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  //SmsSetting Actions ------------------------------------------------------------------
  getSmsSetting({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(hamsazUrl + "basic/hamsaz/SmsSetting")
      .then((res) => {
        commit("setSmsSetting", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addSmsSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(hamsazUrl + "basic/hamsaz/SmsSetting", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSmsSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(hamsazUrl + "basic/hamsaz/SmsSetting/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteSmsSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(hamsazUrl + "basic/hamsaz/SmsSetting", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
};
